import {
  Spacing,
  neutral,
  MediaQueries
} from '@alphorm/ui'

const styleCardTypesDesktop = {
  deleteDiscoverCourse: {
    color: neutral[5],
    fontSize: '18px',
    padding: () => Spacing(0, 0, 0, 4)
  },
  buttonCertificat: {
    width: 189,
    height: 30
  }
}
const styleCardTypesTablet = {
  buttonCertificat: {
    width: 109,
    height: 27
  },
  deleteHistoryCompletedCourses: {
    color: neutral[5],
    fontSize: '18px',
    padding: () => Spacing(0, 0, 0, 3)
  }
}

const styleCardTypesMobile = {
  deleteDiscoverCourse: {
    color: neutral[5],
    fontSize: '18px',
    padding: () => Spacing(0, 0, 0, 3)
  },
  buttonCertificat: {
    width: '100%',
    height: 27
  },
  deleteHistoryCompletedCourses: {
    color: neutral[5],
    fontSize: '18px',
    padding: () => Spacing(0, 0, 0, 3)
  }
}

export default {
  ...styleCardTypesDesktop,
  iconClass: {
    color: neutral[5],
    margin: () => Spacing(0, 0, 0, 4)
  },
  anchorClass: {
    textDecoration: 'none',
    color: 'unset',
    width: '100%'
  },
  card: {
    margin: () => Spacing(0, 0, 3, 0)
  },
  [`${MediaQueries.tablet}`]: {
    ...styleCardTypesTablet
  },
  [`${MediaQueries.mobile}`]: {
    ...styleCardTypesMobile
  }
}
